import { render, staticRenderFns } from "./top-select.vue?vue&type=template&id=74bb5afa&scoped=true"
import script from "./top-select.vue?vue&type=script&lang=js"
export * from "./top-select.vue?vue&type=script&lang=js"
import style0 from "./top-select.vue?vue&type=style&index=0&id=74bb5afa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74bb5afa",
  null
  
)

export default component.exports